module.exports = __webpack_public_path__ + "media/tips/02_chaussures-d8087f45.jpg";